import { ScreenTourData } from './tourTypes';

export const SCREEN_TOURS: Record<string, ScreenTourData> = {
  work_order: {
    screenKey: 'work_order',
    screenTitle: 'Ordem de Serviço (OS)',
    category: 'premium',
    summary: 'A Ordem de Serviço serve para registrar tudo o que você vai fazer para o seu cliente, com fotos, valores e prazos, protegendo seu trabalho e passando mais confiança.',
    steps: [
      {
        title: '1. Para que serve esta tela?',
        description: 'Aqui você cria um documento completo do serviço. Ele serve como um comprovante oficial com a descrição do trabalho, fotos do local e assinatura do cliente.',
        tip: 'Tudo o que você preencher fica salvo automaticamente e pode ser enviado em PDF pelo WhatsApp.'
      },
      {
        title: '2. Preencher os Dados do Cliente',
        description: 'Basta colocar o Nome e o WhatsApp do cliente. Se você digitar o CEP da casa ou empresa dele, a rua, o bairro e a cidade são preenchidos sozinhos para você não precisar digitar tudo.',
        highlight: 'Nome do cliente e WhatsApp',
        tip: 'Ter o WhatsApp preenchido permite enviar o documento pronto diretamente pelo aplicativo.'
      },
      {
        title: '3. Descrever o Serviço e os Valores',
        description: 'Selecione ou escreva o que será feito. Você pode colocar o valor da sua mão de obra e o custo dos materiais que você vai usar.',
        highlight: 'Itens do serviço e valores',
        tip: 'O sistema calcula o valor total automaticamente, sem risco de você errar na conta.'
      },
      {
        title: '4. Fotos do Antes e do Depois',
        description: 'Você pode tirar fotos pelo celular ou escolher da sua galeria. Mostre como o local ou equipamento estava antes de começar e como ficou bonito e finalizado depois.',
        highlight: 'Fotos e Laudo Técnico',
        tip: 'As fotos vão direto para o documento final, comprovando a qualidade do seu serviço.'
      },
      {
        title: '5. Assinatura e Envio no WhatsApp',
        description: 'O cliente pode assinar direto na tela do seu celular usando a ponta do dedo. Depois, basta clicar no botão verde "Ver PDF" para gerar o documento e mandar para o cliente.',
        highlight: 'Assinatura na Tela e Botão Ver PDF',
        tip: 'Não se preocupe: você pode revisar e alterar tudo antes de gerar o documento final.'
      }
    ]
  },
  clients: {
    screenKey: 'clients',
    screenTitle: 'Gestão de Clientes',
    category: 'premium',
    summary: 'Aqui você guarda o contato de todos os seus clientes com segurança, com histórico de atendimentos, botão de WhatsApp direto e rota no GPS.',
    steps: [
      {
        title: '1. Para que serve esta tela?',
        description: 'Esta é a sua agenda profissional de clientes. Aqui você guarda o telefone, endereço e histórico de serviços de cada pessoa, tudo organizado em um só lugar.',
        tip: 'Seus contatos ficam salvos em segurança e não se perdem se você trocar de celular.'
      },
      {
        title: '2. Como Cadastrar um Novo Cliente',
        description: 'Clique no botão verde "+ Novo" no topo da tela. Coloque o Nome e o WhatsApp do cliente. Se você digitar o CEP, a rua, o bairro e a cidade são preenchidos sozinhos.',
        highlight: 'Botão "+ Novo" no canto superior direito',
        tip: 'Se o cliente for pessoa jurídica, basta digitar o CNPJ para preencher a Razão Social automaticamente.'
      },
      {
        title: '3. Encontrar um Cliente na Lista',
        description: 'Use o campo de busca no topo para encontrar qualquer cliente. Você pode digitar apenas o primeiro nome, os números do telefone ou a placa do carro.',
        highlight: 'Campo de busca "Buscar cliente..."',
        tip: 'A lista filtra os resultados na mesma hora conforme você digita.'
      },
      {
        title: '4. Conversar no WhatsApp',
        description: 'No cartão de cada cliente, clique no botão verde do WhatsApp. O aplicativo de conversa abre na hora, sem você precisar salvar o número na memória do aparelho.',
        highlight: 'Botão do WhatsApp no cartão do cliente',
        tip: 'Economiza tempo para enviar orçamentos, recibos e tirar dúvidas com o cliente.'
      },
      {
        title: '5. Traçar Rota no GPS até o Cliente',
        description: 'Toque no botão de mapa/endereço do cliente para abrir a rota direto no Google Maps ou Waze. O navegador já calcula o melhor caminho até a casa dele.',
        highlight: 'Botão de GPS / Google Maps no endereço',
        tip: 'Evita atrasos no trânsito e você chega com tranquilidade ao local de atendimento.'
      }
    ]
  },
  receipts: {
    screenKey: 'receipts',
    screenTitle: 'Emissor de Recibos & PIX',
    category: 'premium',
    summary: 'Aqui você emite comprovantes de pagamento profissionais com Chave PIX, valor recebido, garantia do serviço e envio direto pelo WhatsApp.',
    steps: [
      {
        title: '1. Para que serve esta tela?',
        description: 'Aqui você emite um comprovante de pagamento profissional para o seu cliente quando receber o dinheiro ou o PIX. Isso passa muita confiança e evita desentendimentos.',
        tip: 'O recibo já sai com a data de hoje, o valor certinho e os seus dados profissionais.'
      },
      {
        title: '2. Nome do Pagador e Valor Recebido',
        description: 'Coloque o nome do cliente que fez o pagamento e o valor em reais. Você também pode colocar o CPF dele se ele pedir para declaração.',
        highlight: 'Campos "Quem está pagando" e "Valor Recebido (R$)"',
        tip: 'Se for apenas uma entrada de 50%, selecione a opção "Entrada / Sinal" no tipo de recibo.'
      },
      {
        title: '3. Chave PIX e QR Code para Pagamento',
        description: 'Sua chave PIX cadastrada já aparece no recibo com um QR Code que o cliente consegue ler direto com a câmera do banco dele para pagar na hora.',
        highlight: 'Seção Chave PIX e QR Code',
        tip: 'Você também pode clicar em "Copiar Chave" para colar direto no WhatsApp.'
      },
      {
        title: '4. Garantia do Serviço',
        description: 'O recibo já inclui um termo de garantia (por exemplo: 90 dias de garantia). Isso traz muita tranquilidade para quem contratou o seu serviço.',
        highlight: 'Garantia do Serviço (90 dias padrão)',
        tip: 'Você pode alterar o prazo da garantia de acordo com o combinado com o cliente.'
      },
      {
        title: '5. Enviar no WhatsApp ou Baixar PDF',
        description: 'Clique no botão verde "Enviar WhatsApp" para mandar o recibo pronto em PDF para o cliente, ou toque em "Ver Prévia" para conferir tudo na tela antes de enviar.',
        highlight: 'Botões "Enviar WhatsApp" e "Ver Prévia"',
        tip: 'Todos os recibos emitidos ficam guardados na aba "Histórico" para o seu controle financeiro.'
      }
    ]
  },
  signatures: {
    screenKey: 'signatures',
    screenTitle: 'Assinaturas Digitais & Touch',
    category: 'premium',
    summary: 'Aqui você coleta a assinatura do seu cliente direto na tela do celular com o dedo, com carimbo de data, hora e validade jurídica.',
    steps: [
      {
        title: '1. Para que serve esta tela?',
        description: 'Esta tela serve para você pegar a assinatura do cliente na entrega do serviço ou na aprovação de um orçamento, sem gastar com papel ou impressora.',
        tip: 'A assinatura fica gravada no documento em PDF com carimbo de data e hora para sua total segurança jurídica.'
      },
      {
        title: '2. Documentos que Estão Esperando Assinatura',
        description: 'Suas Ordens de Serviço e Propostas aparecem aqui sozinhas. Os documentos que ainda precisam de assinatura ficam marcados como "Aguardando Assinatura".',
        highlight: 'Filtro "Aguardando" e lista de documentos',
        tip: 'Você não precisa digitar nada de novo: o sistema já puxa o nome do cliente e o valor da proposta.'
      },
      {
        title: '3. Como o Cliente Assina na Tela',
        description: 'Ao clicar no botão "Assinar Agora", abre uma tela limpa no seu celular para o cliente fazer a assinatura com a ponta do dedo, igualzinho a assinar na maquininha de cartão.',
        highlight: 'Botão verde "Assinar Agora"',
        tip: 'Se o cliente errar a assinatura, basta tocar em "Limpar" e assinar de novo com calma.'
      },
      {
        title: '4. Carimbo de Segurança e Comprovação',
        description: 'Assim que o cliente assina, o sistema coloca um carimbo eletrônico oficial com a data e o horário exatos em que ele aprovou e recebeu o serviço.',
        highlight: 'Selo verde "Assinado" com data e hora',
        tip: 'Isso protege o seu trabalho contra reclamações indevidas e comprova que tudo foi entregue.'
      },
      {
        title: '5. Criar um Termo Rápido Avulso',
        description: 'Se você precisar pegar a assinatura do cliente para um serviço rápido ou autorização especial, clique no botão "+ Novo Termo" no topo da tela.',
        highlight: 'Botão verde "+ Novo Termo" no topo',
        tip: 'Basta colocar o nome do cliente, o valor e passar o celular para ele assinar.'
      }
    ]
  },
  calendar: {
    screenKey: 'calendar',
    screenTitle: 'Agenda & Atendimentos',
    category: 'premium',
    summary: 'Aqui você controla seus horários do dia e da semana, agenda novos atendimentos e acompanha pedidos que chegam online.',
    steps: [
      {
        title: '1. Para que serve esta tela?',
        description: 'Esta é a sua grade de horários de trabalho. Aqui você visualiza todos os atendimentos marcados para hoje ou para os próximos dias, sem risco de marcar duas pessoas no mesmo horário.',
        tip: 'Você pode trocar de dia clicando nas setinhas ao lado da data no topo.'
      },
      {
        title: '2. Como Agendar um Novo Horário',
        description: 'Clique no botão verde "+ Novo" no topo. Escolha o cliente, o serviço a ser feito, a data e a hora em que você vai atender.',
        highlight: 'Botão "+ Novo" no canto superior direito',
        tip: 'O sistema avisa na hora se o horário escolhido já estiver ocupado.'
      },
      {
        title: '3. Mudar a Situação do Atendimento',
        description: 'Ao tocar em um agendamento, você pode marcar se o cliente está "Confirmado", se você está "A Caminho" ou se o serviço já foi "Finalizado".',
        highlight: 'Cartões de horários na lista do dia',
        tip: 'Ao finalizar, o sistema já permite emitir o recibo PIX com agilidade.'
      },
      {
        title: '4. Bloquear Horário para Almoço ou Folga',
        description: 'Se você precisar de um intervalo para almoço, consulta médica ou folga, toque no botão amarelo "Bloquear Agenda". O horário fica fechado para atendimentos.',
        highlight: 'Botão amarelo "Bloquear Agenda (Folga / Intervalo)"',
        tip: 'Isso garante o seu momento de descanso sem confusão de horários.'
      },
      {
        title: '5. Link de Agendamento Online da sua Vitrine',
        description: 'Você tem um link profissional da sua empresa para mandar no WhatsApp ou redes sociais. O cliente clica, escolhe o serviço e o horário disponível sozinho.',
        highlight: 'Botão "Link da Vitrine / Agendamento Online"',
        tip: 'O agendamento entra direto na sua tela para você apenas confirmar.'
      }
    ]
  },
  suppliers: {
    screenKey: 'suppliers',
    screenTitle: 'Gestão de Fornecedores',
    category: 'premium',
    summary: 'Aqui você guarda os contatos de fornecedores de materiais, condições de pagamento combinadas e busca automática por CNPJ.',
    steps: [
      {
        title: '1. Para que serve esta tela?',
        description: 'Esta é a sua lista de lojas e distribuidores parceiros onde você compra peças, ferramentas e materiais para o seu trabalho.',
        tip: 'Ter os contatos organizados ajuda você a comparar preços e conseguir descontos melhores nas compras.'
      },
      {
        title: '2. Cadastro Automático pelo CNPJ',
        description: 'Clique no botão verde "Novo Fornecedor". Basta digitar o CNPJ da empresa que o sistema busca a Razão Social, o Nome Fantasia e o Endereço oficial sozinho.',
        highlight: 'Botão "Novo Fornecedor" no topo',
        tip: 'Economiza seu tempo sem precisar digitar nome ou endereço da empresa manualmente.'
      },
      {
        title: '3. Condições de Pagamento Combinadas',
        description: 'Guarde como você costuma pagar cada fornecedor (por exemplo: boleto faturado para 28 dias, PIX à vista com desconto ou cartão).',
        highlight: 'Campo "Condições de Pagamento"',
        tip: 'Evita esquecer os prazos e condições negociadas com o vendedor da loja.'
      },
      {
        title: '4. Filtro por Categorias de Material',
        description: 'Você pode filtrar seus parceiros por categoria (como Elétrica, Hidráulica, Autopeças, Tintas, Embalagens ou Cosméticos).',
        highlight: 'Filtros de categoria abaixo da busca',
        tip: 'Ache rapidamente a loja certa para cada tipo de orçamento que você for montar.'
      },
      {
        title: '5. Chamar o Vendedor no WhatsApp',
        description: 'No cartão de cada fornecedor, toque no botão do WhatsApp ou Telefone para pedir cotações de preços ou solicitar entrega rápida de materiais.',
        highlight: 'Botão de WhatsApp no cartão do fornecedor',
        tip: 'Você manda a lista de materiais direto para o vendedor sem precisar sair da sua obra.'
      }
    ]
  },
  kanban: {
    screenKey: 'kanban',
    screenTitle: 'Funil Comercial & Vendas',
    category: 'premium',
    summary: 'Aqui você acompanha o andamento de cada orçamento, desde o envio até a aprovação, execução na obra e pagamento final.',
    steps: [
      {
        title: '1. Para que serve esta tela?',
        description: 'Esta tela mostra o caminho do seu dinheiro. É como um quadro de avisos com cartões onde você vê quais serviços estão sendo combinados, quais estão em andamento e quais já foram pagos.',
        tip: 'Ajuda você a nunca esquecer de cobrar um cliente ou de entregar um serviço no prazo.'
      },
      {
        title: '2. As Colunas de Etapas',
        description: 'Cada coluna representa uma fase: "Enviados" (esperando resposta), "Aprovados" (cliente aceitou), "Em Execução" (trabalho em andamento) e "Pagos" (dinheiro recebido).',
        highlight: 'Colunas do Funil (Enviados ➔ Aprovados ➔ Executando ➔ Pagos)',
        tip: 'No topo de cada coluna aparece a soma total em reais que você tem naquela fase.'
      },
      {
        title: '3. Mudar o Serviço de Etapa',
        description: 'Basta clicar no botão de ação no rodapé do cartão (como "Iniciar Execução" ou "Concluir Serviço") para ele avançar direto para a próxima coluna.',
        highlight: 'Botão de ação rápida no rodapé de cada cartão',
        tip: 'Você também pode arrastar o cartão com o mouse ou dedo para qualquer coluna.'
      },
      {
        title: '4. Modos de Visualização: Funil, Lista e Métricas',
        description: 'No topo, você pode alternar a visualização: em "Funil" (quadro com colunas), em "Lista" (tabela detalhada) ou em "Métricas" (gráficos de faturamento e taxa de aprovação).',
        highlight: 'Botões "Funil", "Lista" e "Métricas" no cabeçalho',
        tip: 'A visão em lista é ótima para procurar clientes antigos ou exportar relatórios.'
      },
      {
        title: '5. Cobrar Resposta no WhatsApp',
        description: 'No cartão do serviço, você pode tocar no botão do WhatsApp para reenviar a proposta ou lembrar o cliente com uma mensagem educada pronta.',
        highlight: 'Botão de WhatsApp no cartão da proposta',
        tip: 'Lembrar o cliente com jeitinho aumenta muito as chances dele fechar o serviço com você.'
      }
    ]
  },
  radar: {
    screenKey: 'radar',
    screenTitle: 'Preços do Mercado Local',
    category: 'premium',
    summary: 'Aqui você compara seu preço com a média da sua cidade e região para não cobrar barato demais nem perder dinheiro.',
    steps: [
      {
        title: '1. Para que serve esta tela?',
        description: 'Esta tela mostra quanto os profissionais da sua cidade e da sua área estão cobrando pela mão de obra. Assim você sabe se está cobrando o valor justo pelo seu trabalho.',
        tip: 'Cobrar o preço certo valoriza seus anos de prática e garante que suas contas fechem no azul.'
      },
      {
        title: '2. As Três Faixas de Preço da Cidade',
        description: 'Os preços da sua região são divididos em: "Econômico" (iniciantes), "Média de Mercado" (maioria) e "Especialista" (profissionais de confiança com garantia).',
        highlight: 'Termômetro de Faixas de Preço Local',
        tip: 'O sistema mostra um marcador destacando exatamente em qual faixa você está.'
      },
      {
        title: '3. Simulador de Aumento de Lucro',
        description: 'Arraste a barra para ver quanto você ganharia a mais por mês e por ano se ajustasse o valor da sua hora em apenas alguns reais.',
        highlight: 'Barra do "Simulador de Ganho Extra"',
        tip: 'Um pequeno reajuste de R$ 10 na hora pode render mais de R$ 10.000 de lucro extra no ano.'
      },
      {
        title: '4. Respostas Prontas para Pedidos de Desconto',
        description: 'A tela traz respostas educadas e profissionais prontas para você usar quando o cliente disser que "o concorrente cobra metade" ou "está caro".',
        highlight: 'Cartões com respostas prontas e botão Copiar',
        tip: 'Basta tocar em "Copiar Texto" e colar direto na conversa do WhatsApp do cliente.'
      },
      {
        title: '5. Atualizar os Dados da Região',
        description: 'Sempre que quiser atualizar as médias e pesquisas de valores da sua cidade, basta clicar no botão "Atualizar" no topo da tela.',
        highlight: 'Botão "Atualizar" no canto superior direito',
        tip: 'O sistema consulta as médias atualizadas para manter você sempre competitivo.'
      }
    ]
  },
  cockpit: {
    screenKey: 'cockpit',
    screenTitle: 'Painel Financeiro & Lucro (DRE)',
    category: 'premium',
    summary: 'Aqui você acompanha todo o faturamento da sua empresa, seus custos fixos e quanto realmente sobrou de lucro no seu bolso.',
    steps: [
      {
        title: '1. Para que serve esta tela?',
        description: 'Esta é a tela de saúde financeira do seu negócio. Ela mostra de forma clara quanto entrou de dinheiro no mês, quanto saiu para despesas e materiais, e quanto sobrou livre para o seu salário.',
        tip: 'Acaba com aquela dúvida de trabalhar o mês inteiro sem saber para onde o dinheiro foi.'
      },
      {
        title: '2. Meta do Mês e Custos Cobertos',
        description: 'O painel principal no topo mostra se o que você faturou já cobriu todas as contas do mês (aluguel, luz, gasolina, MEI) e o valor do seu salário (pró-labore).',
        highlight: 'Cartão "Meta do Mês (Custos + Seu Salário)"',
        tip: 'A barra verde mostra a porcentagem da meta que você já alcançou até hoje.'
      },
      {
        title: '3. A Conta do seu Lucro Limpo (DRE)',
        description: 'O sistema faz a conta completa para você: Total Faturado ➔ Menos Gastos com Materiais ➔ Menos Despesas Fixas ➔ Lucro Líquido Real que sobrou no seu bolso.',
        highlight: 'Tabela de Demonstrativo de Lucro Real',
        tip: 'Você tem a certeza de que está tendo lucro real em cada serviço prestado.'
      },
      {
        title: '4. Horas Trabalhadas e Oportunidades',
        description: 'A tela mostra quantas horas de serviço você executou e quanto dinheiro a mais você poderia ter ganho se tivesse preenchido os dias ou horários livres da sua agenda.',
        highlight: 'Card "Capacidade e Horas de Trabalho"',
        tip: 'Ajuda você a planejar suas semanas e saber quando abrir promoções ou novos horários.'
      },
      {
        title: '5. Comparar Períodos no Topo',
        description: 'No topo direito da tela, você pode alternar entre ver as contas do "Mês Atual" ou dos "Últimos 30 Dias" corridos.',
        highlight: 'Botões "Mês Atual" e "Últimos 30 Dias" no topo',
        tip: 'Perfeito para conferir se o seu negócio está faturando mais a cada mês.'
      }
    ]
  },
  cost_center: {
    screenKey: 'cost_center',
    screenTitle: 'Centro de Custos & Minha Hora',
    category: 'pro',
    summary: 'Aqui você descobre o valor exato que precisa cobrar por hora para pagar todas as despesas do mês e garantir seu salário no bolso.',
    steps: [
      {
        title: '1. Para que serve esta tela?',
        description: 'Esta tela faz o cálculo mais importante do seu negócio: quanto vale a sua hora de trabalho para que você nunca pague para trabalhar.',
        tip: 'O valor da sua hora calculado aqui será usado em todos os seus orçamentos automáticos.'
      },
      {
        title: '2. Seu Salário Desejado (Pró-Labore)',
        description: 'Coloque quanto você quer ganhar livre todo mês para pagar suas contas pessoais e sustentar sua família com tranquilidade.',
        highlight: 'Campo "Seu Salário Desejado"',
        tip: 'Esse é o seu salário de patrão, que deve estar garantido no preço de cada serviço.'
      },
      {
        title: '3. Suas Despesas Fixas do Mês',
        description: 'Some suas contas da empresa: MEI/impostos, combustível, celular/internet, aluguel da oficina e manutenção de ferramentas.',
        highlight: 'Lista de Despesas Fixas',
        tip: 'Você pode adicionar ou remover despesas a qualquer momento com facilidade.'
      },
      {
        title: '4. As 4 Abas: Hora, Insumos, Kits e Serviços',
        description: 'Navegue pelas abas no topo para cadastrar peças que você compra, montar kits de materiais e definir sua tabela de preços.',
        highlight: 'Abas no topo da tela',
        tip: 'Tudo fica integrado: cadastrou uma peça, ela já fica disponível para os seus orçamentos.'
      }
    ]
  },
  hub: {
    screenKey: 'hub',
    screenTitle: 'Painel Principal de Gestão',
    category: 'gratis',
    summary: 'Este é o centro de comando do seu negócio, onde você acessa todas as ferramentas do seu dia a dia em um só lugar.',
    steps: [
      {
        title: '1. Bem-vindo ao R-MAX!',
        description: 'Este é o seu painel inicial. Daqui você pode criar um orçamento em 1 minuto, ver seus clientes, agendamentos e seu financeiro.',
        tip: 'Você pode usar pelo computador ou pelo celular com a mesma facilidade.'
      },
      {
        title: '2. Elaboração de Orçamentos Rápidos',
        description: 'O botão principal no topo permite criar propostas oficiais em PDF na hora para mandar no WhatsApp do seu cliente.',
        highlight: 'Botão "Orçamentos Rápidos"',
        tip: 'Enviar orçamentos em PDF passa muito mais profissionalismo e evita pedidos de desconto.'
      },
      {
        title: '3. Ferramentas do seu Dia a Dia',
        description: 'Acesse rapidamente a sua Agenda, Cadastro de Clientes, Emissor de Recibos PIX e o Painel Financeiro de Lucro.',
        highlight: 'Lista de Ferramentas Principais',
        tip: 'Toque em qualquer ferramenta para abrir na hora.'
      },
      {
        title: '4. Mais Ferramentas na Gaveta',
        description: 'Toque em "Outras Funcionalidades" no final da tela para ver ferramentas extras como OS com Fotos, Fornecedores e Radar de Mercado.',
        highlight: 'Gaveta "Outras Funcionalidades"',
        tip: 'Tudo o que você precisa para gerenciar sua empresa na palma da sua mão.'
      }
    ]
  },
  orcamento: {
    screenKey: 'orcamento',
    screenTitle: 'Criador de Orçamentos',
    category: 'gratis',
    summary: 'Aqui você cria propostas comerciais completas e profissionais em menos de 1 minuto para enviar pelo WhatsApp.',
    steps: [
      {
        title: '1. Para que serve esta tela?',
        description: 'Esta tela monta uma proposta oficial em PDF com sua foto/marca, descrição clara dos serviços e valores calculados sem erro.',
        tip: 'Clientes fecham serviço muito mais rápido quando recebem um orçamento formal e bonito.'
      },
      {
        title: '2. Nome do Cliente e Obra',
        description: 'Digite o nome do cliente e o telefone. Essas informações saem formatadas no cabeçalho do documento.',
        highlight: 'Campos "Nome do Cliente" e "WhatsApp"',
        tip: 'Ter o telefone preenchido cria o botão para mandar o PDF no WhatsApp diretamente.'
      },
      {
        title: '3. Descrever os Serviços e Materiais',
        description: 'Escreva o que será feito ou clique nos serviços sugeridos da sua profissão. O sistema calcula a mão de obra pela sua hora justa.',
        highlight: 'Itens do Orçamento e Materiais',
        tip: 'Você pode separar o que é mão de obra e o que é material para o cliente entender tudo certinho.'
      },
      {
        title: '4. Gerar e Compartilhar Proposta',
        description: 'Toque no botão de salvar para gerar a proposta em PDF pronta para download ou envio direto.',
        highlight: 'Botão "Gerar Orçamento / Salvar"',
        tip: 'O orçamento fica salvo no seu histórico e entra automaticamente no seu Funil de Vendas.'
      }
    ]
  },
  profile: {
    screenKey: 'profile',
    screenTitle: 'Meu Perfil Profissional',
    category: 'gratis',
    summary: 'Aqui você coloca a sua foto ou logotipo, seus contatos e suas redes sociais para sair em todos os documentos oficiais.',
    steps: [
      {
        title: '1. Para que serve esta tela?',
        description: 'Aqui você personaliza a identidade visual da sua empresa. Sua foto, marca, telefone e anos de experiência aparecerão nas suas propostas e recibos.',
        tip: 'Um perfil completo transmite total autoridade e confiança para o seu cliente.'
      },
      {
        title: '2. Foto ou Logotipo da Empresa',
        description: 'Envie uma foto sua de trabalho ou o logotipo da sua empresa. Ela será colocada no topo de todos os PDFs gerados.',
        highlight: 'Área de Upload de Logotipo/Foto',
        tip: 'Uma imagem nítida faz sua proposta parecer a de uma grande empresa.'
      },
      {
        title: '3. Dados de Contato e Redes Sociais',
        description: 'Preencha seu WhatsApp, Instagram e endereço de atendimento. Seus clientes poderão tocar nesses links direto nas propostas.',
        highlight: 'Campos de Contato e Redes',
        tip: 'Facilita para os clientes recomendarem o seu trabalho para amigos e familiares.'
      },
      {
        title: '4. Salvar suas Alterações',
        description: 'Ao terminar, clique no botão verde "Salvar Cadastro" no topo para gravar todas as suas informações com segurança.',
        highlight: 'Botão "Salvar Cadastro" no topo direito',
        tip: 'Você pode atualizar seus dados e foto sempre que desejar.'
      }
    ]
  }
};
